import { render, staticRenderFns } from "./useCourse.vue?vue&type=template&id=b829c7d2&scoped=true&"
import script from "./useCourse.vue?vue&type=script&lang=js&"
export * from "./useCourse.vue?vue&type=script&lang=js&"
import style0 from "./useCourse.vue?vue&type=style&index=0&id=b829c7d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b829c7d2",
  null
  
)

export default component.exports